import { t } from 'i18next'

import * as yup from 'yup'

/**
 * Form constants
 */

// Section 1
const DESCRIPTION = 'description'
const DONE = 'done'

const today = new Date()
today.setHours(0, 0, 0, 0)

/**
 * Form model
 */
const formModel = () => {
  return {
    [DESCRIPTION]: {
      label: `Report on progress`,
      name: DESCRIPTION,
    },
    [DONE]: {
      label: `Done`,
      name: DONE,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [DESCRIPTION]: '',
  [DONE]: false,
}


export default formModel
